import majorService from "@/services/major";
export default {
  state: {
    majorDefault: {
      degreeType: null,
      name: "",
      content: "",
    },
    major: {}
  },
  mutations: {
    setMajor(state, payload) {
      state.major = JSON.parse(
        JSON.stringify({ ...state.majorDefault, ...payload })
      );
    }
  },
  actions: {
    async setMajor({ commit }, payload) {
      payload.degreeType =
        (payload.degreeType && payload.degreeType.id) ||
        payload.degreeType ||
        null;
      commit("setMajor", payload);
    },
    resetMajor({ commit }) {
      commit("setMajor", {});
    },
    async removeMajorCvs(context, payload) {
      await majorService.removeCvs(payload);
    },
    async removeMajor(context, payload) {
      const { id } = payload;
      await majorService.remove(id);
    }
  }
};
